import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface AdminProtectedRouteProps {
  children: ReactNode;
}

export function AdminProtectedRoute({ children }: AdminProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  // Wait for both auth and role to load before making decisions
  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Allow admins and co-admins to access admin routes
  const isAdmin = userRole === "admin";
  const isCoAdmin = userRole === "employee" && userRoleData?.employee_type === "co_admin";

  if (!isAdmin && !isCoAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
